/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { contact } from '../../common/contact';
import { address } from '../../common/address';
import { entity } from '../../common/entity';
import { identification } from '../../common/identification';
import { servicedate } from './servicedate';
import { benefitinformation } from './benefitinformation';
import { requestvalidation } from './requestvalidation';

export class coverage extends IceEntity {
  coverage_key: string = "";
  payer_name: string = "";
  payer_key: string = "";
  payer_id_code_qualifier: string = "";
  payer_identification: string = "";
  insured_indicator: boolean = false;
  insurance_type_code: string = "";
  claim_filing_indicator_code: string = "";
  maintenance_type_code: string = "";
  maintenance_reason_code: string = "";
  student_status_code: string = "";
  handicap_indicator: boolean = false;
  birth_sequence_number: number = 0;
  record_version: number = 0;
  offline_record_status: number = 0;
  control_number: string = "";
  subscriber_onfile_entity_key: string = "";
  subscriber_onfile_address_key: string = "";
  payer_address_key: string = "";
  payer_phone: string = "";
  payer_fax: string = "";

  CONS: contact[] = [];
  ADS: address[] = [];
  ENTS: entity[] = [];
  IDS: identification[] = [];
  RELEVDTS: servicedate[] = [];
  REQRESULTS: requestvalidation[] = [];
  BFTS: benefitinformation[] = [];

  gettablename(): string {
    return "COVERAGE";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "CONS") return true;
    else if (ColumnName == "ADS") return true;
    else if (ColumnName == "ENTS") return true;
    else if (ColumnName == "IDS") return true;
    else if (ColumnName == "RELEVDTS") return true;
    else if (ColumnName == "REQRESULTS") return true;
    else if (ColumnName == "BFTS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "CONS") return "CONTACT";
    else if (ColumnName == "ADS") return "ADDRESS";
    else if (ColumnName == "ENTS") return "ENTITY";
    else if (ColumnName == "IDS") return "IDENTIFICATION";
    else if (ColumnName == "RELEVDTS") return "SERVICE_DATE";
    else if (ColumnName == "REQRESULTS") return "REQUEST_VALIDATION";
    else if (ColumnName == "BFTS") return "BENEFIT_INFORMATION";

    return null;
  }
}
